import type { AssetsRecommendationAssetItem } from '@/modules/Asset/interface/Recommendation';
import { type FC, useState } from 'react';
import { PATHS } from '@/config/paths';
import { salesforceOpportunityConfig } from '@/config/salesForce';
import { useSendClickEvent } from '@/modules/Customer/http/client/mutations/useSendClickEvent';
import { CardFlipHorizontal } from '@/components/elements/CardFlipHorizontal';
import { BackFace } from './BackFace';
import { FrontFace } from './FrontFace';

export const CardAssetRecomendation: FC<CardAssetRecomendationProps> = ({
  handleInvestIn,
  ...data
}) => {
  const [isShowingFront, setIsShowingFront] = useState(true);

  const { mutate: sendClickEvent } = useSendClickEvent();

  const handleSendClick = (values: { label: string; url: string }) => {
    sendClickEvent({
      label: salesforceOpportunityConfig.sendClickEvent.recommnendation.label(
        values.label,
        values.url
      ),
    });
  };

  return (
    <CardFlipHorizontal
      showBack={!isShowingFront}
      frontFace={
        <FrontFace
          data={data}
          setIsShowingFront={() => {
            setIsShowingFront(false);
            handleSendClick({
              label: `Recomendação ${data?.ticker}`,
              url: `${PATHS.hubs.recommendation}?busca=${data?.ticker}`,
            });
          }}
        />
      }
      backFace={
        <BackFace
          data={data}
          handleInvestIn={(data: CardAssetRecomendationData) => {
            handleInvestIn(data);
            handleSendClick({
              label: `Investir em ${data?.name}`,
              url: '/investir',
            });
          }}
          setIsShowingFront={setIsShowingFront}
        />
      }
      w="13.25rem"
      h="8.75rem"
    />
  );
};

export type CardAssetRecomendationProps = CardAssetRecomendationData & {
  handleInvestIn: (data: CardAssetRecomendationData) => void;
};

export type CardAssetRecomendationData = Pick<
  AssetsRecommendationAssetItem,
  'id' | 'name' | 'recommendation' | 'subcategory' | 'thumb'
> & {
  ticker: string;
};
